import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=05ae3b0c&scoped=true"
import script from "./Version.vue?vue&type=script&lang=ts"
export * from "./Version.vue?vue&type=script&lang=ts"
import style0 from "./Version.vue?vue&type=style&index=0&id=05ae3b0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae3b0c",
  null
  
)

export default component.exports